import { render, staticRenderFns } from "./addCommodity.vue?vue&type=template&id=3784963a&scoped=true&"
import script from "./addCommodity.vue?vue&type=script&lang=js&"
export * from "./addCommodity.vue?vue&type=script&lang=js&"
import style0 from "./addCommodity.vue?vue&type=style&index=0&id=3784963a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3784963a",
  null
  
)

component.options.__file = "addCommodity.vue"
export default component.exports